import * as api from '../../services/androidClient'

export const FETCH_ANDROIDCLIENTS= 'FETCH_ANDROIDCLIENTS';
export const FETCH_ANDROIDCLIENT = 'FETCH_ANDROIDCLIENT';


export const fetchAndroidClient = (id) => ({
    type: FETCH_ANDROIDCLIENT,
    payload: {
        promise: api.findAndroidClient({id: id})
    }
});


export const fetchAndroidClients = (params, pagination, sort, extra) => {

    return {
        type: FETCH_ANDROIDCLIENTS,
        payload: {
            promise: api.findAndroidClients(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/androidClient.js